import React from 'react';
import { CSSObject, Icon } from '@chakra-ui/react';
import { CheckCircle } from '@styled-icons/bootstrap/CheckCircle';
import { Stop } from '@styled-icons/octicons/Stop';

export const EstReturnsLabel: CSSObject = {
  bg: 'alpha.500',
  color: 'alpha.900',
  fontWeight: 'bold',
  height: '100%',
  alignItems: 'center',
  px: '1',
  width: 'auto',
};

export const PendingBetContainer: CSSObject = {
  bg: 'orange.300',
  borderRadius: 'base',
  w: 'full',
  color: 'orange.900',
  justifyContent: 'center',
};

export const BetApprovalText: CSSObject = {
  fontSize: 'xs',
  color: 'alpha.900',
  fontWeight: 'bold',
  textShadow: '0px 1px 1px rgba(0, 0, 0, 0.35)',
};

export const BetPendingApprovalText: CSSObject = {
  fontSize: 'xs',
};

export const BetRejectedText: CSSObject = {
  fontSize: 'xs',
  color: 'red.100',
  fontWeight: 'bold',
  textShadow: '0px 1px 1px rgba(0, 0, 0, 0.35)',
};

export const ApprovedBetContainer: CSSObject = {
  color: 'alpha.900',
  bg: 'alpha.400',
  borderRadius: 'md',
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',
  w: 'full',
  justifyContent: 'center',
};

export const RejectedBetContainer: CSSObject = {
  bg: 'red.700',
  boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.20)',
  borderRadius: 'md',
  w: 'full',
  justifyContent: 'center',
};

export const FooterContainer: CSSObject = {
  bg: 'white',
  px: '0',
  h: '6',
  overflow: 'hidden',
  borderRadius: 'base',
  fontSize: '2xs',
};

export const FooterText: CSSObject = {
  fontWeight: 'bold',
  color: 'red.600',
};

export const IconApprovedBet = () => (
  <Icon as={CheckCircle} boxSize="4" mr="2" />
);

export const IconRejectedBet = () => <Icon as={Stop} boxSize="4" mr="2" />;
